import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AccountService } from '../_services/account/account.service';
import { take } from "rxjs";


/**
 * Will send the Bearer JWT for each request only when the user has been authenticated 
 * by check local storage
 * @param req 
 * @param next 
 * @returns 
 */
export const JwtInterceptor: HttpInterceptorFn = (req, next) => {

  const accountService = inject(AccountService);
  const user = accountService.currentUserSource.getValue();

  if (user && user.token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${user.token}`
      }
    });
  }

  return next(req);
};
